import { Box, Container, Divider, Typography } from '@mui/material';
import { LIST_USERS, GET_CLASSROOM } from "../../../graphql/admin-requests";
import { useLazyQuery } from "@apollo/client";
import React, { useState, useEffect, useCallback, useRef } from 'react';
import UserByClassroomListResults from './UserByClassroomListResults';
import { useReactToPrint } from 'react-to-print';
import { PrintIcon } from '../../Icons';
import CustomIconButton from '../../AdminComponents/subcomponents/CustomIconButton';
import { styled } from '@mui/material/styles';

const PREFIX = 'UserByClassroomList';

const classes = {
    listContainer: `${PREFIX}-listContainer`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.listContainer}`]: {
        '@media print': {
        },
        '@media screen': {
            maxHeight: "90vh",
            overflowY: "auto",
        }
    }
}));

function UserByClassroomList({ classroomUid }) {
    const [users, setUsers] = useState([]);
    const [classroom, setClassroom] = useState({});

    const [getUsers] = useLazyQuery(LIST_USERS, {
        onCompleted: (data) => { setUsers(data.allUsers.nodes); },
        fetchPolicy: 'cache-and-network'
    });

    const [getClassroom] = useLazyQuery(GET_CLASSROOM, {
        onCompleted: (data) => { setClassroom(data.classroomByUid); },
        fetchPolicy: 'cache-and-network'
    });

    const toPrintRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => toPrintRef.current,
        pageStyle: `
        @media all {
            .page-break {
              display: none;
            }
        }

        @media print {
            html, body {
                height: initial !important;
                overflow: initial !important;
                -webkit-print-color-adjust: exact;
            }

            .page-break {
                display: block;
                page-break-before: always;
            }
         }

        @page {
            size: auto;
        }
        `
    });



    const loadData = useCallback(() => {
        const vars = { variables: { classroomUid } };
        getUsers(vars);
        getClassroom(vars)

    }, [getUsers, getClassroom, classroomUid]);

    useEffect(() => {
        loadData();
    }, [loadData])

    return (
        <Root>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <CustomIconButton color="primary" variant="contained" onClick={handlePrint} icon={<PrintIcon />} title="Imprimer" />
            </Box>
            <Container ref={toPrintRef} component="main" className={classes.listContainer}>
                <Typography component="h1" variant="h5">{classroom.name}</Typography>
                <Divider style={{ marginTop: '5px' }} />
                <Box>
                    <Container maxWidth={false}>
                        <Box>
                            <UserByClassroomListResults users={users} />
                        </Box>
                    </Container>
                </Box>
            </Container>
        </Root>
    );
}

export default UserByClassroomList;